{
    "yes": "Oui",
    "no": "Non",
    "confirm": "Confirmer",
    "apply": "Appliquer",
    "cancel": "Annuler",
    "show": "Montrer",
    "hide": "Cacher",
    "send": "Envoyer",
    "close": "Fermer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "loading": "Chargement",
    "expand": "Développer",
    "collapse": "Effondrement",
    "fullscreenEnter": "Entrez en plein écran",
    "fullscreenExit": "Quitter le plein écran",
    "center": "Centre",
    "bottom": "Bas",
    "hidden": "Caché",
    "day": "Jour",
    "month": "Mois",
    "year": "Année",
    "placeholder": "Faites une question",
    "createdAt": "Date de création",
    "all": "Tous",
    "today": "Aujourd'hui",
    "date": "Date de naissance",
    "yesterday": "Hier",
    "last_7_days": "7 derniers jours",
    "copied": "Copié !",
    "missingData": "Informations manquantes",
    "last_30_days": "30 derniers jours",
    "selected": "Choisi",
    "page": "page",
    "actions": "Actes",
    "next": "Suivant",
    "previous": "Précédent",
    "copy": "Copie",
    "copyRawCode": "Copier le code brut",
    "copyToClipboard": "Copier dans le presse-papier",
    "showOriginalText": "Afficher l'original",
    "showTranslatedText": "Afficher la traduction",
    "exactPosition": "Position exacte",
    "uncertain": "Incertain",
    "question": "Question",
    "nothingFound": "Rien trouvé",
    "venue": "Lieu",
    "searchVenue": "Rechercher un lieu...",
    "popularLanguages": "Populaires",
    "allLanguages": "Toutes les langues",
    "memoriBlockedTitle": "Bloqué",
    "memoriBlockedUntil": "Agent bloqué jusqu'à {{date}}",
    "memoriBlockedAnon": "Actuellement \"{{name}}\"Je ne peux pas répondre, reviens ici {{date}}",
    "memoriBlockedReasonExceedChats": "car il a dépassé le seuil mensuel de chats autorisés.",
    "memoriBlockedGiverHelper": "Vous pouvez toujours le gérer en tant qu'administrateur, mais les autres utilisateurs ne pourront pas interagir avec lui.",
    "generatedByAI": "Réponse générée par l'IA, peut occasionnellement générer des informations incorrectes",
    "reasoning": "Réflexion...",
    "whyThisAnswer": "Pourquoi cette réponse ?",
    "whyThisAnswerHelper": "Cette réponse a été générée automatiquement par une intelligence artificielle basée sur ces contenus vérifiés.",
    "receiverLabel": "Assigné à",
    "completionsEnabled": "L'IA avancée peut répondre avec des réponses générées automatiquement qui peuvent parfois contenir des informations incorrectes",
    "completionProviderDown": "Ce Agent est intégré à une IA générative de {{provider}}, mais il est actuellement indisponible. ",
    "completionProviderMajorOutage": "Ce Agent est intégré à une IA générative de {{provider}}, mais il est actuellement indisponible. Cette fonctionnalité ne sera pas disponible tant que le service ne sera pas restauré.",
    "completionProviderPartialOutage": "Ce Agent est intégré à une IA générative de {{provider}}, mais il est actuellement indisponible. Cette fonctionnalité ne sera pas disponible tant que le service ne sera pas restauré.",
    "completionProviderDegraded": "Ce Agent est intégré à une IA générative de {{provider}}, mais il est actuellement indisponible. Cette fonctionnalité ne sera pas disponible tant que le service ne sera pas restauré.",
    "completionProviderFallbackName": "un prestataire externe",
    "completionProviderCheckStatusPage": "Vérifier la page d'état",
    "boardOfExperts": "Conseil d'experts",
    "birthDate": "Date de naissance",
    "birthDateHelper": "Nous demandons votre date de naissance uniquement pour activer ou désactiver les fonctionnalités qui ont des restrictions d'âge",
    "underage": "Vous devez être au moins {{age}} ans pour s'inscrire.",
    "underageTwinSession": "Vous devez être au moins {{age}} ans pour interagir avec ce Agent.",
    "errorFetchingSession": "Erreur lors du chargement de la session",
    "errorGettingReferralURL": "Erreur lors du chargement du référent",
    "errorReopeningSession": "Erreur lors de la re-ouverture de la session",
    "ageVerification": "Vérification de l'âge",
    "ageVerificationText": "Pour interagir avec ce Agent, vous devez être au minimum {{minAge}} ans.",
    "nsfw": "NSFW : Ce jumeau contient du contenu pour adultes",
    "deepThought": "Pensée profonde",
    "deepThoughtHelper": "Deep Thought est une fonctionnalité avancée de l'IA qui vous permettra d'exploiter pleinement vos conversations en les gardant une trace. ",
    "deepThoughtDisclaimerTitle": "Pensée profonde activée",
    "deepThoughtDisclaimer": "Deep Thought est une fonctionnalité avancée de l'IA qui vous permettra d'exploiter pleinement vos conversations en les gardant une trace. ",
    "deepThoughtPreDisclaimerUnlogged": "Connectez-vous pour activer Deep Thought.",
    "deepThoughtPreDisclaimerNotAllowed": "Deep Thought est désactivé car vous n'avez pas consenti à son utilisation, vous pouvez le modifier à tout moment dans les paramètres de votre compte.",
    "notEnoughCredits": "L'auteur de ce Agent n'a pas suffisamment de crédits pour répondre à votre question.",
    "confirmDialog": {
        "title": "Voulez-vous quitter cette page ?",
        "message": "Les modifications que vous avez apportées seront perdues."
    },
    "knownFacts": {
        "title": "Faits connus",
        "description": "Détails des informations partagées entre vous et {{memoriName}}",
        "type": "Taper",
        "typeShortTerm": "Court terme",
        "typeLongTerm": "Long terme",
        "typeHelper": "Types :\n",
        "text": "Texte",
        "deleteSuccess": "Fait connu supprimé",
        "deleteConfirmTitle": "Supprimer un fait connu",
        "deleteConfirmMessage": "Êtes-vous sûr de vouloir supprimer ce fait connu ?",
        "deleteSelectedConfirmTitle": "Supprimer les faits connus sélectionnés",
        "deleteSelectedConfirmMessage": "Etes-vous sûr de vouloir supprimer les faits connus sélectionnés ?"
    },
    "auth": {
        "title": "Authentification",
        "useRecoveryTokens": "Utiliser des jetons de récupération",
        "tokens": "Jetons",
        "addToken": "Ajouter un jeton",
        "invalidCredentials": "Identifiants invalides",
        "usePassword": "Utiliser le mot de passe",
        "atLeast": "Au moins"
    },
    "widget": {
        "instruct": "Instruire",
        "test": "Tester",
        "sound": "Son",
        "position": "Préférences de position",
        "settings": "Paramètres",
        "share": "Partager",
        "shareChat": "Partager le chat",
        "sendOnKeypress": "Appuyez sur Entrée pour envoyer",
        "sendOnClick": "Cliquez sur Envoyer",
        "boardOfExperts": "Conseil d'experts",
        "showExpertsInTheBoard": "Afficher les experts dans ce conseil",
        "expertsInTheBoard": "Experts dans ce conseil",
        "goToIntegrationsToCustomizeAvatar": "Pour personnaliser l'avatar, allez dans Partager et personnalisez la page publique"
    },
    "exportChatHistory": {
        "exportPDF": "Exporter le chat en PDF",
        "exporting": "Exportation en cours...",
        "empty": "Aucun historique de chat à exporter",
        "pdfNotSupported": "L'exportation PDF n'est pas prise en charge dans ce navigateur",
        "success": "Chat exporté en PDF avec succès",
        "error": "Échec de l'exportation du chat en PDF. Veuillez réessayer."
    },
    "write_and_speak": {
        "loadingChatHistory": "Chargement de l'historique des discussions...",
        "noChatHistoryAvailable": "Aucun historique des discussions disponible",
        "noResultsFound": "Aucun résultat trouvé pour \"{{searchText}}\"",
        "searchInChatHistory": "Rechercher dans l'historique des chats...",
        "latestFirst": "Plus récents d'abord",
        "oldestFirst": "Plus anciens d'abord",
        "exportChat": "Exporter le Chat",
        "conversationStartedLabel": "Conversation démarrée"
    },
    "write_and_speak": {
        "micButtonPopover": "Cliquez sur le bouton pour parler",
        "micButtonPopoverListening": "Cliquez sur le bouton pour arrêter de parler",
        "pageInstructExplanation": "Pour m'apprendre de nouvelles choses, cliquez sur le bouton INSTRUCTEZ-MOI pour commencer",
        "pageTryMeExplanation": "Pour me parler, cliquez sur le bouton START pour commencer",
        "pagePrivacyExplanation": "Les conversations sont visibles par l'auteur de l'agent",
        "pagePrivacyExplanationTooltip": "En commençant la conversation, nous vous informons que :\n\n- Toutes les conversations avec cet agent sont visibles par l'auteur de l'agent\n- Si vous utilisez la chat comme utilisateur anonyme, l'auteur pourra voir le contenu de la conversation et votre adresse IP\n- Si vous utilisez la chat comme utilisateur enregistré (connecté), l'auteur pourra voir le contenu de la conversation et votre nom d'utilisateur\n- L'auteur utilise ces informations pour améliorer les fonctionnalités de l'agent et pour vous fournir un meilleur service\n- En continuant la conversation, vous acceptez ces conditions.",
        "pagePrivacyExplanationList": {
            "allConversations": "Toutes les conversations avec cet agent sont visibles par l'auteur de l'agent",
            "anonymousUser": "Pour les utilisateurs anonymes : l'auteur verra le contenu de la conversation et votre adresse IP",
            "registeredUser": "Pour les utilisateurs enregistrés : l'auteur verra le contenu de la conversation et votre nom d'utilisateur",
            "contentAndUsername": "L'auteur peut voir le contenu, votre nom d'utilisateur et votre adresse IP",
            "contentAndIpAddress": "L'auteur peut voir le contenu et votre adresse IP",
            "authorUsesInfo": "L'auteur utilise ces informations pour améliorer les fonctionnalités de l'agent et pour vous fournir un meilleur service. En continuant la conversation, vous acceptez ces conditions."
        },
        "downloadChat": "Télécharger le chat",
        "instructButton": "INSTRUCTEZ-MOI",
        "tryMeButton": "COMMENCER",
        "resumeButton": "RÉSUMER",
        "chatHistory": "Historique des discussions",
        "chatHistoryDescription": "Afficher l'historique des discussions avec cet agent",
        "loadingChatHistory": "Chargement de l'historique des discussions...",
        "noChatHistoryAvailable": "Aucun historique des discussions disponible",
        "noResultsFound": "Aucun résultat trouvé pour \"{{searchText}}\"",
        "searchInChatHistory": "Rechercher dans l'historique des chats...",
        "latestFirst": "Plus récents d'abord",
        "oldestFirst": "Plus anciens d'abord",
        "exportChat": "Exporter le Chat",
        "settingsHeaderLabel": "Configurez ici si vous souhaitez définir la mémoire comme parole continue et modifiez les secondes de silence si vous souhaitez les personnaliser.",
        "continuousSpeechLabel": "Discours continu",
        "continuousSpeechDisabled": "Discours continu désactivé car l'agente est en mode muté",
        "holdToSpeak": "Attends pour parler",
        "releaseToEndListening": "Relâcher pour terminer l'écoute",
        "pressAndHoldToSpeak": "Appuyez et maintenez pour parler",
        "microphoneMode": "Mode micro",
        "hideEmissionsLabel": "Masquer le texte émis par le Agent",
        "secondsLabel": "Régler les secondes",
        "controlsPosition": "Position des commandes",
        "tryMeHeaderLabel": "ESSAYER",
        "unknownPosition": "Position inconnue",
        "fieldPlace": "Écrivez le lieu (par exemple « Milano »)",
        "showMapLinkFor": "Afficher la position sur la carte",
        "useMyPosition": "Utiliser ma position",
        "myPosition": "Votre poste",
        "updatingPosition": "Mise à jour du poste...",
        "placeNotFound": "Lieu introuvable !",
        "requirePosition": "Insérez votre position avant de commencer",
        "requirePositionHelp": "Pour parler à {{name}} vous devez décider si vous souhaitez ou non fournir votre poste. ",
        "dontWantToProvidePosition": "Je ne veux pas donner ma position",
        "attachmentsLabel": "Enrichissez votre message",
        "iWantToTalkToIn": "je veux parler à {{name}} dans",
        "message": "message",
        "messages": "messages",
        "page": "Page {{current}} de {{total}}"
    },
    "artifact": {
        "close": "Fermer",
        "size": "Taille",
        "generated": "Généré",
        "download": "Télécharger",
        "print": "Imprimer",
        "external": "Ouvrir dans une nouvelle fenêtre",
        "type": "Type",
        "fullscreen": "Plein écran",
        "exitFullscreen": "Quitter le plein écran",
        "copy": "Copier",
        "generatedAt": "Généré le",
        "open": "Ouvrir",
        "code": "Code",
        "preview": "Aperçu",
        "copied": "Copié !",
        "error": "Erreur",
        "generatingPdf": "Génération du PDF...",
        "copying": "Copie en cours...",
        "moreCopyOptions": "Plus d'options de copie",
        "copyAs": "Copier en tant que",
        "downloadAsMarkdown": "Télécharger en Markdown",
        "downloadRawMarkdownText": "Télécharger le texte markdown brut",
        "downloadAsPdf": "Télécharger en PDF",
        "exportAsPdfDocument": "Exporter en document PDF",
        "downloadAsHtml": "Télécharger en HTML",
        "downloadFormattedHtml": "Télécharger le HTML formaté",
        "viewMode": "Mode Affichage",
        "codeMode": "Mode Code",
        "refresh": "Actualiser",
        "share": "Partager",
        "downloadAsJson": "Télécharger en JSON",
        "downloadJsonData": "Télécharger les données JSON",
        "downloadAsPng": "Télécharger en PNG",
        "downloadPngImage": "Télécharger l'image PNG",
        "downloadAsJpeg": "Télécharger en JPEG",
        "downloadJpegImage": "Télécharger l'image JPEG",
        "downloadAsGif": "Télécharger en GIF",
        "downloadGifImage": "Télécharger l'image GIF",
        "downloadAsWebp": "Télécharger en WebP",
        "downloadWebpImage": "Télécharger l'image WebP",
        "copyAsSvg": "Copier en SVG",
        "copySvgSourceCode": "Copier le code source SVG",
        "copyAsPlainText": "Copier en texte brut",
        "copyAsText": "Copier en texte",
        "copyAsLanguage": "Copier en {{language}}",
        "copyLanguageCode": "Copier le code {{language}}",
        "copyWithoutSyntaxHighlighting": "Copier sans coloration syntaxique",
        "copyTextContent": "Copier le contenu texte",
        "pdfExportNotSupported": "L'exportation PDF n'est pas prise en charge dans ce navigateur",
        "popupBlocked": "Popup bloqué ! Veuillez activer les popups pour imprimer.",
        "safariPdfInstructions": "Export PDF ouvert dans une nouvelle fenêtre. Veuillez utiliser Cmd+P (Mac) ou Ctrl+P (Windows) pour imprimer et sauvegarder en PDF."
    },
    "upload": {
        "loginRequired": "Connexion requise",
        "pastedText": "texte-collé",
        "uploadNotification": "Échec du téléchargement",
        "loginRequiredDescription": "Veuillez vous connecter pour télécharger des images",
        "uploadFiles": "Télécharger des fichiers ({{shortcut}}+O pour ouvrir le sélecteur de fichiers)",
        "uploadFilesWithShortcut": "{{shortcut}}+O pour ouvrir le sélecteur de fichiers",
        "uploadImages": "Télécharger des images",
        "uploadDocuments": "Télécharger des documents",
        "replace": "Remplacer",
        "remaining": "restant",
        "maxReached": "Limite atteinte",
        "maxImagesReached": "Vous pouvez télécharger jusqu'à {{max}} images",
        "apiClientNotConfigured": "API client non configuré correctement pour le téléchargement de médias",
        "fileReadingFailed": "Échec de la lecture du fichier",
        "uploadFailed": "Échec du téléchargement",
        "uploadSuccess": "Téléchargement réussi",
        "uploadSuccessDescription": "Le fichier a été téléchargé avec succès",
        "dragAndDropFiles": "Glissez et déposez les fichiers ici pour les ajouter à la chat",
        "contextSizeExceedsLimit": "La taille du contexte dépasse la limite. Essayez de réduire le nombre de fichiers ou le contenu de la conversation.",
        "filesNotAddedMaxAllowed": "{{count}} fichier(s) non ajouté(s) (maximum {{max}} fichiers autorisés).",
        "documentsNotAddedMaxAllowed": "{{count}} document(s) non ajouté(s) (maximum {{max}} fichiers autorisés).",
        "imagesNotAddedMaxAllowed": "{{count}} image(s) non ajoutée(s) (maximum {{max}} fichiers autorisés).",
        "documentsNotAddedContextSize": "{{count}} document(s) non ajouté(s) (limite de taille du contexte)."
    },
    "media": {
        "title": "Titre",
        "editAttributes": "Modifier les attributs du média",
        "uploadMimeTypeNotAllowed": "Le type de fichier n'est pas autorisé",
        "uploadSizeLimitMessage": "La taille téléchargée est trop grande (max {{size}}Mo)",
        "uploadWrongResolutionMessage": "La résolution doit être {{width}}x{{height}} pixels",
        "memoriNameAlreadyUsed": "Vous avez déjà un jumeau portant ce nom",
        "uploadHelperImages": "Téléchargez un fichier avec l'extension png, jpg, jpeg ou gif, et ayant au maximum une taille de {{size}}Mo",
        "uploadHelper": "Téléchargez un fichier ayant au maximum une taille de {{size}}Mo",
        "uploadError": "Échec du téléchargement",
        "square": "carré",
        "scaleRatio": "Rapport d'échelle",
        "addMediaLabel": "Ajouter un média",
        "insertThisMediaMsg": "Insérez ces médias",
        "mediaUploadMessage": "Cliquez pour charger un nouveau média",
        "addLinkLabel": "Ajouter un lien",
        "linkKey": "URL",
        "linkValue": "Titre du lien",
        "insertThisLink": "Insérer un lien vers {{url}} avec titre {{title}}"
    },
    "gamification": {
        "level": "Niveau",
        "points": "points",
        "memoriReachedLevel": "est devenu plus évolué et a atteint le niveau",
        "levelGoToStatistics": "{{Agent}} est au niveau {{level}} avec {{points}} points. ",
        "congratulationsNewLevel": "Félicitations, vous avez atteint un nouveau niveau !",
        "congratulationsNewLevelDescription": "Votre Agent est devenu plus évolué avec {{points}} points, regardez le",
        "statistics": "statistiques"
    },
    "login": {
        "login": "Se connecter",
        "logout": "Déconnexion",
        "user": "Utilisateur",
        "loggedDrawerTitle": "Salut, {{name}}!",
        "userNameRequired": "Nom d'utilisateur requis",
        "userName": "Nom d'utilisateur",
        "userNamePlaceholder": "Inserisci le nom d'utilisateur",
        "loginDrawerTitle": "Se connecter",
        "signupDrawerTitle": "S'inscrire",
        "newUserSignUp": "Nouvel utilisateur ?",
        "signUp": "S'inscrire!",
        "alreadyHaveAnAccount": "Vous avez déjà un compte ?",
        "backToLogin": "Retour à la connexion",
        "registrationDisabled": "L'inscription est désactivée",
        "contactAdmin": "Contacter l'administrateur pour demander l'accès",
        "userNameOrEmail": "Nom d'utilisateur ou email",
        "email": "E-mail",
        "emailFormatError": "Veuillez insérer un email valide",
        "username": "Nom d'utilisateur",
        "usernameContainsReservedWord": "Le nom d'utilisateur contient un mot réservé, veuillez en choisir un autre",
        "usernameFormatError": "Le nom d'utilisateur doit comporter au moins 3 caractères et contenir uniquement des lettres, des chiffres et _",
        "otpCode": "Le code de vérification",
        "resendVerificationCode": "Renvoyer le code",
        "resentVerificationCode": "Code de confirmation envoyé ! ",
        "welcomeTitle": "Bon retour",
        "welcomeDescription": "Entrez votre code de vérification à 4 chiffres pour continuer vers votre compte",
        "otpTitle": "Entrez le code de vérification",
        "otpDescription": "Entrez le code à 4 chiffres que vous avez généré dans votre compte",
        "otpStep1": "Cliquez sur le bouton ci-dessous pour ouvrir votre compte",
        "otpStep2": "Générez un code de vérification à 4 chiffres (valide pendant 60 secondes)",
        "otpStep3": "Revenez ici et entrez le code",
        "startOtpLogin": "Commencer la vérification",
        "generateOtp": "Générer le code",
        "otpTimer": "Le code expire dans {{seconds}} secondes",
        "otpInvalidFormat": "Veuillez entrer un code valide à 4 chiffres",
        "otpInvalid": "Code de vérification invalide",
        "otpError": "Erreur lors de la validation du code. Veuillez réessayer.",
        "otpSuccess": "Connexion réussie !",
        "otpEmailTitle": "Entrez votre email",
        "otpEmailDescription": "Entrez votre adresse email pour recevoir un code de vérification",
        "otpCodeDescription": "Entrez le code à 4 chiffres envoyé à {{email}}",
        "emailPlaceholder": "Entrez votre email",
        "sendOtp": "Envoyer le code",
        "resendOtp": "Renvoyer le code",
        "resending": "Envoi en cours...",
        "backToEmail": "Retour à l'email",
        "otpSent": "Code de vérification envoyé !",
        "otpResent": "Code renvoyé avec succès !",
        "otpSendError": "Erreur lors de l'envoi du code. Veuillez réessayer.",
        "emailRequired": "Email requis",
        "emailInvalid": "Veuillez entrer une adresse email valide",
        "otpNotFound": "Code de vérification introuvable",
        "otpExpired": "Le code de vérification a expiré",
        "otpMissing": "Le code de vérification est requis",
        "otpSuccessMessage": "Vérification réussie ! Redirection...",
        "otpSuccessDescription": "Votre compte a été vérifié avec succès. Vous allez être redirigé sous peu.",
        "otpHelp": "Entrez le code à 4 chiffres de votre email",
        "emailHelp": "Nous vous enverrons un code de vérification",
        "userFetchError": "Erreur lors du chargement des données utilisateur. Veuillez réessayer.",
        "otpStep1Title": "Entrez l'Email",
        "otpStep2Title": "Vérifiez l'Email",
        "otpStep3Title": "Entrez le Code",
        "featureFast": "Rapide",
        "featureSecure": "Sécurisé",
        "featureMobile": "Mobile",
        "password": "Mot de passe",
        "newPassword": "Nouveau mot de passe",
        "confirmPassword": "Confirmez le mot de passe",
        "currentPassword": "Mot de passe actuel",
        "passwordMatchingError": "Les mots de passe ne correspondent pas.",
        "passwordFormatError": "Le mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre majuscule, une lettre minuscule et un symbole.",
        "pwdWeak": "Faible",
        "pwdAcceptable": "Acceptable",
        "pwdStrong": "Fort",
        "mustChangePassword": "Vous devez changer votre mot de passe",
        "passwordChange": "Changer le mot de passe",
        "emailChange": "Changer d'e-mail",
        "avatarChange": "Changer d'avatar",
        "underage": "Vous devez être au moins {{age}} ans pour s'inscrire.",
        "optional": "Facultatif",
        "birthDate": "Date de naissance",
        "birthDateHelper": "Nous demandons votre date de naissance uniquement pour activer ou désactiver les fonctionnalités qui ont des restrictions d'âge",
        "missingData": "Informations manquantes",
        "missingDataHelper": "Nous savons que c'est un peu ennuyeux, mais nous avons besoin de plus d'informations pour finaliser votre inscription.",
        "goToAccountToChangeYourPreferences": "Vous pouvez modifier votre choix à tout moment depuis la page de votre compte.",
        "deepThoughtExplaination": "Deep Thought est une fonctionnalité avancée de l'IA qui vous permettra d'exploiter pleinement vos conversations en les gardant une trace. ",
        "tnCAndPPAcceptedHelper": "Depuis votre dernière connexion, les conditions générales et la politique de confidentialité ont changé. ",
        "privacyLabel": "J'ai lu et accepté le",
        "privacyAndCookiePolicy": "Politique de confidentialité et de cookies",
        "and": "et",
        "termsOfService": "Conditions d'utilisation",
        "pAndCUAccepted": "J'accepte les conditions d'utilisation de Deep Thought",
        "editAccount": "Modifier le compte",
        "save": "Sauvegarder",
        "successfullyLoggedIn": "{{username}} s'est connecté avec succès"
    },
    "chatLogs": {
        "anyMessage": "Tout message",
        "atLeast": "Au moins {{count}} messages",
        "atLeast2": "Au moins 2 messages",
        "atLeast3": "Au moins 3 messages",
        "atLeast5": "Au moins 5 messages",
        "atLeast10": "Au moins 10 messages",
        "atLeast15": "Au moins 15 messages",
        "atLeast20": "Au moins 20 messages",
        "customMinimumMessages": "Personnaliser le nombre de messages"
    },
    "success": "Succès",
    "Error": "Erreur",
    "internal server error": "Oupsie, désolé... Quelque chose s'est mal passé sur le serveur",
    "error": "Erreur",
    "error.loading": "Erreur lors du chargement du contenu.",
    "error.generic": "Oupsie, désolé... quelque chose s'est mal passé.",
    "error.serverNotResponding": "Nous effectuons une maintenance ou publions des mises à jour. ",
    "error.notFound": "Oupsie, nous n'avons pas trouvé la page que vous cherchiez.",
    "error.goBackTo": "Vous pouvez essayer de revenir au",
    "error.reloadPage": "Recharger la page",
    "error.tryAgain": "Essayer à nouveau",
    "error.unauthorized": "Vous n'êtes pas autorisé à consulter ce contenu.",
    "error.unprocessableEntity": "Erreur lors du traitement de la demande. ",
    "errors": {
        "TENANT_NOT_FOUND": "Locataire introuvable",
        "TENANT_REGISTRATION_DISABLED": "L'inscription sur cette plateforme est désactivée",
        "TENANT_MISSING_NAME": "Locataire : nom manquant",
        "TENANT_MAX_USERS_REACHED": "Nombre maximum d'utilisateurs atteint",
        "TENANT_MAX_ADMINS_REACHED": "Nombre maximum d'utilisateurs administrateurs atteint",
        "TENANT_ALREADY_EXISTS": "Le locataire existe déjà",
        "TENANT_MISSING_DESCRIPTION": "Locataire : description manquante",
        "TENANT_CANT_SET_COMPLETION_PROVIDER": "Locataire : impossible de définir le fournisseur de complétion",
        "TENANT_INVALID_TYPE": "Locataire : type non valide",
        "USER_NOT_CONFIRMED": "L'utilisateur n'est toujours pas confirmé",
        "USER_NOT_FOUND": "Utilisateur introuvable",
        "USER_OR_PASSWORD_INVALID": "Utilisateur ou mot de passe invalide",
        "USER_MUST_CHANGE_PASSWORD": "Vous devez changer votre mot de passe",
        "USER_MUST_ENTER_VERIFICATION_CODE": "Vous devez entrer le code de vérification",
        "USER_MISSING_TENANT": "Utilisateur : locataire manquant",
        "USER_MISSING_NAME": "Utilisateur : le nom est manquant",
        "USER_MISSING_PASSWORD": "Utilisateur : mot de passe manquant",
        "USER_MISSING_EMAIL": "Utilisateur : E-mail manquant",
        "USER_MISSING_VERIFICATION_CODE": "Utilisateur : Code de vérification manquant",
        "USER_NAME_ALREADY_USED": "Nom d'utilisateur déjà utilisé",
        "USER_PASSWORD_NOT_CONFORMING_TO_POLICY": "Le mot de passe ne répond pas aux règles de sécurité",
        "USER_EMAIL_ALREADY_USED": "E-mail déjà utilisé",
        "USER_EMAIL_INVALID": "E-mail invalide",
        "USER_VERIFICATION_CODE_INVALID": "Code de vérification invalide",
        "USER_MISSING_NAME_OR_EMAIL": "Nom d'utilisateur ou e-mail manquant",
        "USER_NAME_INVALID": "Nom d'utilisateur invalide",
        "USER_HAS_ONE_OR_MORE_MEMORI": "L'utilisateur possède une ou plusieurs mémoires",
        "USER_MISSING_NEW_PASSWORD": "Utilisateur : nouveau mot de passe manquant",
        "USER_NOTHING_TO_DO": "Rien à faire",
        "USER_CANT_CREATE_MEMORI": "L'utilisateur n'est pas autorisé à créer des Agent",
        "USER_MAX_MEMORI_REACHED": "Nombre maximum de Agent atteint",
        "USER_ORDER_BY_INVALID": "Ordre par non valide",
        "USER_TOO_MANY_ATTEMPTS": "Trop de tentatives",
        "USER_MUST_ACCEPT_TNC_AND_PP": "Vous devez accepter les termes et conditions",
        "USER_BIRTH_DATE_CANT_BE_CHANGED": "La date de naissance ne peut pas être modifiée",
        "USER_CANT_SET_COMPLETION_PROVIDER": "Utilisateur : non autorisé à gérer le fournisseur de complétion",
        "USER_CANT_ENABLE_DEEP_THOUGHT": "Utilisateur : non autorisé à gérer Deep Thought",
        "USER_CANT_ENABLE_DCM_INTEGRATION": "Utilisateur : non autorisé à gérer l'intégration DCM",
        "USER_CANT_ENABLE_CHAINING_OR_BOARD_OF_EXPERTS": "Utilisateur : non autorisé à gérer des chaînages ou des groupes d'experts",
        "USER_CREATION_BILLING_DENIED_PERMISSION": "Vous n'avez pas assez de crédits pour créer un Agent",
        "USER_HAS_ONE_OR_MORE_COMPLETION_CONFIGS": "L'utilisateur dispose d'une ou plusieurs configurations de complétion",
        "USER_CANT_BE_DELETED": "L'utilisateur ne peut pas être supprimé",
        "MEMORI_NOT_FOUND": "Mémoire introuvable",
        "MEMORI_NOT_ACCESSIBLE": "Mémoires non accessibles",
        "MEMORI_ONLY_OWNER_CAN_CHANGE_GIVER_TAG_AND_PIN": "Seul le propriétaire peut modifier le tag ou le code PIN",
        "SESSION_NOT_FOUND": "Séance introuvable",
        "SESSION_IS_NOT_ADMINISTRATIVE": "Séance non administrative",
        "SESSION_EXPIRED": "Session expirée",
        "SESSION_OTP_NOT_FOUND": "Code de vérification introuvable",
        "SESSION_OTP_EXPIRED": "Le code de vérification a expiré",
        "SESSION_MISSING_TEMPORARY_TOKEN": "Le code de vérification est requis",
        "MEMORI_MISSING_CONFIGURATION": "Agent : configuration manquante",
        "MEMORI_CONFIGURATION_NOT_FOUND": "Agent : configuration introuvable",
        "MEMORI_INVALID_PRIVACY_TYPE": "Agent : type de confidentialité non valide",
        "MEMORI_MISSING_PASSWORD": "Agent : mot de passe manquant",
        "MEMORI_INVALID_TOTAL_NUMBER_OF_RECOVERY_TOKENS": "Agent : nombre total de jetons de récupération invalides",
        "MEMORI_INVALID_MINIMUM_NUMBER_OF_RECOVERY_TOKENS": "Agent : nombre minimum de jetons de récupération invalides",
        "MEMORI_INVALID_VOICE_TYPE": "Agent : type de voix invalide",
        "MEMORI_MISSING_NAME": "Jumeau : nom manquant",
        "MEMORI_MISSING_PASSWORD_OR_RECOVERY_TOKENS": "Agent : mot de passe ou jeton de récupération manquant",
        "MEMORI_INVALID_ID": "Jumeau : pièce d'identité invalide",
        "MEMORI_NAME_ALREADY_USED": "Nom jumeau déjà utilisé",
        "MEMORI_INVALID_PIN": "Agent : code PIN invalide",
        "MEMORI_GIVER_TAG_PIN_CHANGE_REQUIRES_SEPARATE_OPERATION": "Agent : le changement de TAG et de PIN nécessite des opérations distinctes",
        "MEMORI_NO_PASSWORD_WHEN_PUBLIC": "Agent : aucun mot de passe requis lorsqu'il est public",
        "MEMORI_DEEP_THOUGHT_REQUIRES_COMPLETIONS": "Deep Thought nécessite que les complétions soient activées",
        "MEMORI_BOARD_OF_EXPERTS_REQUIRES_COMPLETIONS": "Le groupe d'experts exige que les complétions soient activées",
        "MEMORI_INVALID_COMPLETION_CONFIG": "Agent : configuration des complétions non valide",
        "MEMORI_MACRO_FUNCTIONS_REQUIRES_COMPLETIONS": "Macro fonctions requiert que les complétions soient activées",
        "MEMORI_BLOCKING_DATE_MISSING_OR_WRONG": "Gemmeau : date de blocage manquante ou incorrecte",
        "MEMORI_LIST_FILTER_NOT_SPECIFIED": "Gemmeau : filtre non spécifié",
        "MEMORI_TRANSFER_MISSING_DESTINATION_USER": "Transfert : utilisateur de destination manquant",
        "MEMORI_TRANSFER_INVALID_DESTINATION_USER_ID": "Transfert : ID utilisateur de destination non valide",
        "MEMORI_TRANSFER_DESTINATION_USER_DATA_INCONSISTENT": "Transfert : données utilisateur de destination non valides",
        "MEMORI_TRANSFER_NOTHING_TO_DO": "Transfert : rien à faire",
        "MEMORI_CONFIGURATION_CANT_BE_CHANGED": "Mémoires : la configuration ne peut pas être modifiée",
        "MEMORI_MISSING_NEW_PASSWORD": "Souvenirs : nouveau mot de passe manquant",
        "MEMORI_FEATURE_REQUIRES_SUBSCRIPTION": "La fonctionnalité nécessite un abonnement",
        "MEMORI_SESSION_NOT_FOUND": "Séance introuvable",
        "MEMORI_SESSION_DOESNT_ACCEPT_MEDIA": "Séance ne pas accepter les médias",
        "INTEGRATION_NOT_FOUND": "Intégration introuvable",
        "MEMORI_SESSIONS_INVALID_DATE_FROM_FORMAT": "Date invalide du format",
        "MEMORI_SESSIONS_INVALID_DATE_TO_FORMAT": "Date à formater invalide",
        "INTEGRATION_INVALID_TYPE": "Type d'intégration invalide",
        "INTEGRATION_ALREADY_EXISTS": "L'intégration existe déjà",
        "INTEGRATION_MEMORI_IS_NOT_PUBLIC": "Les mémoires non publiques ne peuvent pas être intégrées",
        "INTEGRATION_MISSING_INVOCATION_TEXT": "Intégration : texte d'invocation manquant",
        "INTEGRATION_MISSING_DEVICE_EMAILS": "Intégration : e-mail de l'appareil manquant",
        "INTEGRATION_MEMORI_IS_EMPTY": "Les mémoires vides ne peuvent pas être intégrées",
        "INTEGRATION_MISSING_PRIVACY_POLICY": "Intégration : politique de confidentialité manquante",
        "INTEGRATION_MISSING_CATEGORY": "Catégorie d'intégration manquante",
        "INTEGRATION_MISSING_DESCRIPTION": "Description de l'intégration manquante",
        "INTEGRATION_INVALID_INVOCATION_TEXT": "Texte d'appel invalide",
        "INTEGRATION_GOOGLE_NO_MORE_AVAILABLE": "Google Home n'est plus disponible",
        "UPLOAD_REQUIRES_MULTIPART_ENCODING": "Le téléchargement nécessite un codage en plusieurs parties",
        "UPLOAD_MISSING_CONTENT_TYPE_BOUNDARY": "Téléchargement : limite de type de contenu manquante",
        "UPLOAD_MAX_LENGTH_EXCEEDED": "Téléchargement : taille maximale dépassée",
        "UPLOAD_FILE_IS_EMPTY": "Télécharger : fichier vide",
        "UPLOAD_INVALID_FILE_TYPE_OR_SIGNATURE": "Téléchargement : type de fichier ou signature non valide",
        "UPLOAD_MISSING_FILE_NAME": "Télécharger : nom de fichier manquant",
        "UPLOAD_INVALID_MEMORY_ID": "Télécharger : ID de contenu invalide",
        "UPLOAD_MISSING_FILE_CONTENT": "Télécharger : contenu du fichier manquant",
        "ASSET_NOT_FOUND": "Actif introuvable",
        "ASSET_NOT_ACCESSIBLE": "Actif non accessible",
        "ASSET_MISSING_SESSION_ID": "Élément : ID de session manquant",
        "ASSET_INVALID_FILE_NAME": "Élément : nom de fichier non valide",
        "ASSET_MALWARE_SCAN_THREATS_FOUND": "Élément : menaces de scan de malware trouvées",
        "INVITATION_NOT_FOUND": "Invitation introuvable",
        "INVITATION_NOT_ACCESSIBLE": "Invitation non accessible",
        "INVITATION_ALREADY_ACCEPTED": "Invitation déjà acceptée",
        "INVITATION_ALREADY_REJECTED": "Invitation déjà rejetée",
        "INVITATION_MISSING_DESTINATION_EMAIL": "Invitation : e-mail de destination manquant",
        "INVITATION_DESTINATION_EMAIL_INVALID": "Invitation : e-mail de destination invalide",
        "INVITATION_MISSING_TAG": "Invitation : étiquette manquante",
        "INVITATION_MISSING_PIN": "Invitation : code PIN manquant",
        "INVITATION_INVALID_PIN": "Invitation : code PIN invalide",
        "INVITATION_INVALID_TYPE": "Invitation : type non valide",
        "INVITATION_MISSING_DESTINATION_NAME": "Invitation : le nom de la destination est manquant",
        "INVITATION_TAG_PIN_CANT_BE_CHANGED": "Invitation : le tag et le code PIN ne peuvent pas être modifiés",
        "INVITATION_CANT_BE_CHANGED": "Intation : ne peut pas être modifié",
        "ACTIONLOG_INVALID_USER_ID": "ID utilisateur invalide",
        "ACTIONLOG_INVALID_DATE_FROM_FORMAT": "Date de : format non valide",
        "ACTIONLOG_INVALID_DATE_TO_FORMAT": "Date de : format non valide",
        "ACTIONLOG_INVALID_MEMORI_ID": "Identifiant Agent invalide",
        "CONSUMPTIONLOG_INVALID_TYPE": "Type de journal invalide",
        "CONSUMPTIONLOG_INVALID_DATE_FROM_FORMAT": "Date de : format non valide",
        "CONSUMPTIONLOG_INVALID_DATE_TO_FORMAT": "Date de : format non valide",
        "CONSUMPTIONLOG_INVALID_USER_ID": "ID utilisateur invalide",
        "CONSUMPTIONLOG_INVALID_MEMORI_ID": "Identifiant Agent invalide",
        "NOTIFICATIONPREFS_INVALID_CHATLOG_EXTRACTION_PERIOD": "Notifications : période d'extraction du journal de discussion non valide",
        "BROADCAST_NOT_ALLOWED": "Broadcast non autorisé",
        "INVALID_NOTIFICATION_TYPE": "Type de notification non valide",
        "NOTIFICATION_NOT_FOUND": "Notification introuvable",
        "INVALID_NOTIFICATION_FILTER": "Filtre de notification non valide",
        "INVALID_NOTIFICATION_PERIOD": "Période de notification non valide",
        "PROCESS_INVALID_TYPE": "Type de processus invalide",
        "PROCESS_ALREADY_RUNNING": "Processus déjà en cours",
        "PROCESS_NOT_FOUND": "Processus introuvable",
        "IMPORTCSV_MISSING_ROWS": "Import CSV : lignes manquantes",
        "IMPORTCSV_MISSING_CSV": "Importation CSV : CSV manquant",
        "IMPORTCSV_MISSING_SEPARATOR": "Import CSV : séparateur manquant",
        "IMPORTCSV_INVALID_SEPARATOR": "Importation CSV : séparateur non valide",
        "IMPORTCSV_MISSING_HEADERS": "Import CSV : en-têtes manquants",
        "IMPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Import CSV : séparateur de variante de titre manquant",
        "IMPORTCSV_INVALID_RECEIVER_ID": "Importation CSV : ID de destinataire non valide",
        "IMPORTCSV_INVALID_MEDIA_LINK": "Importation CSV : lien média non valide",
        "IMPORTCSV_INVALID_LINK_TITLE_HANDLING": "Importation CSV : titre du lien invalide",
        "IMPORTCSV_UNDETECTABLE_CHAR_ENCODING": "Import CSV : encodage de caractères indétectable",
        "IMPORTCSV_CANT_IMPORT_TO_SECRET_MEMORI": "Importation CSV : impossible d'importer dans les mémoires secrètes",
        "IMPORTTXT_MISSING_ROWS": "Importation de TXT : lignes manquantes",
        "IMPORTTXT_INVALID_GRANULARITY": "Importer TXT : granularité invalide",
        "IMPORTTXT_INVALID_RECEIVER_ID": "Importer TXT : ID de destinataire invalide",
        "IMPORTTXT_INVALID_MEDIA_LINK": "Importer TXT : lien média non valide",
        "IMPORTTXT_INVALID_LINK_TITLE_HANDLING": "Importer TXT : titre du lien invalide",
        "IMPORTTXT_UNDETECTABLE_CHAR_ENCODING": "Import TXT : encodage de caractères indétectable",
        "IMPORTTXT_CANT_IMPORT_TO_SECRET_MEMORI": "Importation TXT : impossible d'importer vers les mémoires secrètes",
        "IMPORTTXT_IMPORT_LIMIT_EXCEEDED": "Importer TXT : limite d'importation dépassée",
        "IMPORTTXT_IMPORT_ON_GPT4_REQUIRES_API_KEY": "Importer TXT : l'importation sur GPT-4 nécessite une clé API",
        "IMPORTTXT_IMPORT_REQUIRES_PAYING": "Importer TXT : l'importation nécessite un forfait payant",
        "IMPORTTXT_BILLING_DENIED_PERMISSION": "Importer TXT : vous n'avez pas assez de crédits pour l'opération",
        "IMPORT_MISSING_ROWS": "Importation : lignes manquantes",
        "IMPORT_CANT_IMPORT_TO_SECRET_MEMORI": "Importation : impossible d'importer vers les mémoires secrètes",
        "IMPORTMEMORI_INVALID_MEMORI_SPECS": "Importation MEMORI : spécifications de mémoire non valides",
        "IMPORT_MISSING_JSONL": "Importation : JSONL manquant",
        "IMPORTMEMORI_INVALID_SPECS": "Importation MEMORI : spécifications non valides",
        "EXPORT_MISSING_PASSWORD": "Exportation : mot de passe manquant",
        "EXPORTCSV_MISSING_CSV_SPECS": "Exportation CSV : spécifications CSV manquantes",
        "EXPORTCSV_MISSING_SEPARATOR": "Export CSV : séparateur manquant",
        "EXPORTCSV_INVALID_SEPARATOR": "Exportation CSV : séparateur non valide",
        "EXPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "Exportation CSV : séparateur de variante de titre manquant",
        "EXPORTCSV_MISSING_NEW_LINE_CHAR": "Exportation CSV : caractère de nouvelle ligne manquant",
        "EXPORTCSV_INVALID_NEW_LINE_CHAR": "Exportation CSV : caractère de nouvelle ligne non valide",
        "EXPORTCSV_MISSING_PASSWORD": "Export CSV : mot de passe manquant",
        "EXPORTJSONL_MISSING_JSONL_SPECS": "Export JSONL : spécifications JSONL manquantes",
        "EXPORTJSONL_MISSING_PLATFORM": "Export JSONL : plateforme manquante",
        "EXPORTJSONL_INVALID_PLATFORM": "Export JSONL : plateforme non valide",
        "EXPORTJSONL_MISSING_PASSWORD": "Export JSONL : mot de passe manquant",
        "EXPORTJSONL_EXPORT_REQUIRES_PAYING": "Exportation JSONL : l'exportation nécessite un forfait payant",
        "ANALYSIS_MISSING_QUERY": "Analyse : requête manquante",
        "ANALYSIS_CANT_ANALYZE_SECRET_MEMORI": "Analyse : impossible d'analyser les souvenirs secrets",
        "ANALYSIS_USER_QUERY_MATCH_REQUIRES_DEEP_THOUGHT": "Analyse : la correspondance avec la requête de l'utilisateur nécessite une réflexion approfondie",
        "BADGE_ASSIGNMENT_WRONG_OR_MISSING_CREDENTIALS": "Attribution des badges : identifiants incorrects ou manquants",
        "BADGE_ASSIGNMENT_MISSING_REF_ID": "Affectation du badge : ID de référence manquant",
        "BADGE_ASSIGNMENT_OUTCOME_NOT_FOUND": "Attribution des badges : résultat introuvable",
        "BADGE_ASSIGNMENT_MISSING_ASSERTION_URL": "Attribution du badge : URL d'assertion manquante",
        "BADGE_ASSIGNMENT_MISSING_BADGE_URL": "Attribution du badge : URL du badge manquante",
        "BADGE_ASSIGNMENT_MISSING_ISSUER_URL": "Attribution du badge : URL de l'émetteur manquante",
        "BADGE_ASSIGNMENT_INVALID_URL": "Attribution du badge : URL invalide",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT": "Affectation du badge : destinataire manquant",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_TYPE": "Attribution du badge : type de destinataire inconnu",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_IDENTITY": "Attribution du badge : identité du destinataire manquante",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_HASH_TYPE": "Attribution du badge : type de hachage du destinataire manquant",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_HASH_TYPE": "Attribution du badge : type de hachage du destinataire inconnu",
        "BADGE_ASSIGNMENT_WRONG_RECIPIENT_IDENTITY": "Attribution du badge : identité du destinataire incorrecte",
        "BADGE_NOT_FOUND": "Badge introuvable",
        "OUTCOME_NO_DCM_CONFIGURED": "Résultat : aucun DCM configuré",
        "OUTCOME_USER_BADGES_DISABLED": "Résultat : badges utilisateur désactivés",
        "COMPLETION_CONFIG_MISSING_NAME": "Configuration des complétions : nom manquant",
        "COMPLETION_CONFIG_MISSING_PROVIDER": "Configuration des complétions : fournisseur manquant",
        "COMPLETION_CONFIG_MISSING_ENDPOINT": "Configuration des complétions : point de terminaison manquant",
        "COMPLETION_CONFIG_MISSING_API_KEY": "Configuration des complétions : clé API manquante",
        "COMPLETION_CONFIG_MISSING_MODEL": "Configuration des complétions : modèle manquant",
        "COMPLETION_CONFIG_NO_PURPOSE_SPECIFIED": "Configuration des complétions : au moins un type de complétions doit être spécifié",
        "COMPLETION_CONFIG_INVALID_NAME": "Configuration des complétions: nom non valide",
        "COMPLETION_CONFIG_INVALID_PURPOSE": "Configuration des complétions : type de complétions non valide",
        "COMPLETION_CONFIG_INVALID_ENDPOINT": "Configuration des achèvements : point de terminaison non valide",
        "COMPLETION_CONFIG_INCONSISTENT_ENDPOINT": "Configuration des complétions : point de terminaison incohérent",
        "COMPLETION_CONFIG_INVALID_PROVIDER": "Configuration des complétions : fournisseur non valide",
        "COMPLETION_CONFIG_NOT_FOUND": "Configuration des complétions : introuvable",
        "COMPLETION_CONFIG_NOT_ACCESSIBLE": "Configuration des complétions : non accessible",
        "COMPLETION_CONFIG_NAME_RESERVED": "Configuration des complétions : nom réservé",
        "COMPLETION_CONFIG_NAME_ALREADY_EXISTS": "Configuration des complétions : le nom existe déjà",
        "COMPLETION_CONFIG_VISIBILITY_CHANGE_NOT_ALLOWED": "Configuration des complétions : changement de visibilité non autorisé",
        "COMPLETION_CONFIG_MISSING_MANDATORY_PREFIX": "Configuration des complétions : préfixe obligatoire manquant",
        "COMPLETION_CONFIG_VISIBILITY_NOT_PERMITTED": "Configuration des complétions : visibilité non autorisée",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_NOT_PERMITTED": "Configuration des complétions : utilisation comme défaut non autorisée",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_REQUIRES_TENANT_VISIBILITY": "Configuration des complétions : utilisation comme défaut nécessite la visibilité du locataire",
        "COMPLETION_CONFIG_CHARGEABLE_NOT_PERMITTED": "Configuration des complétions : chargeable non autorisé",
        "COMPLETION_CONFIG_INVALID_APPLY_TO": "Configuration des complétions : apply to non valide",
        "COMPLETION_CONFIG_APPLY_TO_TENANT_NOT_ALLOWED": "Configuration des complétions : apply to tenant non autorisé",
        "TRUSTED_APPLICATION_NOT_FOUND": "Application de confiance introuvable",
        "TRUSTED_APPLICATION_NOT_ACCESSIBLE": "Application de confiance non accessible",
        "TRUSTED_APPLICATION_ALREADY_EXISTS": "Application de confiance existe déjà",
        "TRUSTED_APPLICATION_MISSING_NAME": "Application de confiance : nom manquant",
        "TRUSTED_APPLICATION_MISSING_DESCRIPTION": "Application de confiance : description manquante",
        "TRUSTED_APPLICATION_MISSING_ICON": "Application de confiance : icône manquante",
        "TRUSTED_APPLICATION_MISSING_URL": "Application de confiance : URL manquante"
    }
}
